import React from "react";
import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { PreviewPrimaryAction } from "@/features/previews/shared/components/PreviewPrimaryAction";
import { PdfHeader } from "./components/PdfHeader";
import { DocumentViewerContainer } from "./components/DocumentViewerContainer";
import { FileMetadata } from "./components/FileMetadata";
import { usePdfData } from "./hooks/usePdfData";
import { isClient } from "@/utils/browser";
import { Link } from "@/components/Link";
import { Typography } from "@/components/Typography";
import { checkValidURL, formatClientUrl } from "@/utils/formHelper";
import type { QRProps } from "@/contexts/QREditorContext/types";

import "./PdfTemplate.scss";

const SHOW_MODAL_WIDTH = 888;
export const PdfTemplate = (props: QRProps<"pdf">) => {
  const {
    translations,
    isInitialPreview,
    companyName,
    pdfDescription,
    pdfName,
    pdfFileName,
    pdfFileUrl,
    size,
    themeColor,
    websiteUrl,
    logoUrl,
  } = usePdfData(props);

  const downloadPDF = () => {
    if (!pdfFileUrl) return;
    const downloadLink = document.createElement("a");
    downloadLink.href = pdfFileUrl;
    downloadLink.download = pdfName || pdfFileName || "pdf_download.pdf";
    downloadLink.click();
  };

  const showPDF = () => {
    if (typeof window === "undefined" || !pdfFileUrl) return;
    const pdfWindow = window.open("");
    if (pdfWindow) {
      pdfWindow.document.write(
        `<iframe src="${pdfFileUrl}" width="100%" height="100%" style="border: 0"></iframe>`
      );
      pdfWindow.document.body.style.margin = "0px";
    }
  };

  const onOpenPdf = () => {
    if (!pdfFileUrl) return;

    if (isClient() && window.innerWidth < SHOW_MODAL_WIDTH) {
      downloadPDF();
    } else {
      showPDF();
    }
  };

  return (
    <PhoneLayout
      page="pdf"
      dataQA="preview-pdf-container"
      backgroundColor={themeColor?.backgroundColor}
      hasIncludeBrowser
      isInitPreview={isInitialPreview}
    >
      <div className="pdf-template">
        <Typography
          Tag="p"
          spacing={4}
          classname="body-s u-bold pdf-company-name"
          style={{ padding: "16px 0", margin: 0, textAlign: "center" }}
        >
          {companyName}
        </Typography>

        <div className="pdf-template__content">
          <PdfHeader
            pdfName={pdfName}
            pdfDescription={pdfDescription}
          />

          <div style={{ display: "none" }}>
            <FileMetadata size={size} />
          </div>

          <DocumentViewerContainer
            isInitPreview={isInitialPreview}
            pdfFileUrl={pdfFileUrl}
            logoUrl={logoUrl}
          />

          <PreviewPrimaryAction
            text={translations?.preview_button_text}
            onClick={onOpenPdf}
            buttonColor={themeColor?.buttonColor}
            className="pdf-template__button-see"
          />
        </div>

        {websiteUrl && (
          <Typography
            Tag="p"
            spacing={6}
            classname="u-bold body-s pdf-template__url"
          >
            <Link
              externalLink
              className="Preview-layout__link"
              href={checkValidURL(websiteUrl)}
              prefetch={false}
            >
              {formatClientUrl(websiteUrl)}
            </Link>
          </Typography>
        )}
      </div>
    </PhoneLayout>
  );
};
